var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgOutlookEmailIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_16320_23040)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.9997 12.5995C24.001 12.3978 23.904 12.21 23.7441 12.1045H23.7413L23.7312 12.0985L15.415 6.80652C15.379 6.78044 15.3418 6.7566 15.3033 6.73513C14.9822 6.55704 14.6008 6.55704 14.2797 6.73513C14.2412 6.75661 14.204 6.78044 14.1681 6.80652L5.85181 12.0985L5.84177 12.1045C5.5876 12.2744 5.50968 12.6337 5.66774 12.9069C5.71431 12.9874 5.77845 13.0545 5.8546 13.1023L14.1709 18.3943C14.2069 18.4202 14.2442 18.444 14.2825 18.4657C14.6036 18.6438 14.985 18.6438 15.3061 18.4657C15.3445 18.444 15.3817 18.4202 15.4178 18.3943L23.734 13.1023C23.9002 12.9982 24.0016 12.8063 23.9997 12.5995Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.8234 9.0666H12.2809V14.4444H6.8234V9.0666ZM22.8855 3.6V1.13999C22.8986 0.524937 22.4458 0.0147381 21.8736 0H7.71141C7.13926 0.0147381 6.68639 0.524937 6.6995 1.13999V3.6L15.0716 5.99999L22.8855 3.6Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.69922 3.60156H12.2806V9.00156H6.69922V3.60156Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8587 3.60156H12.2773V9.00156L17.8587 14.4016H22.882V9.00156L17.8587 3.60156Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2773 9H17.8587V14.4H12.2773V9Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.2773 14.3984H17.8587V19.7984H12.2773V14.3984Z",
    fill: "#0364B8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.82031 14.4453H12.2778V19.3341H6.82031V14.4453Z",
    fill: "#14447D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8594 14.3984H22.8826V19.7984H17.8594V14.3984Z",
    fill: "#0078D4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.745 13.0714L23.7344 13.0774L15.4181 18.1054C15.3818 18.1294 15.345 18.1522 15.3065 18.1726C15.1652 18.2449 15.0118 18.2857 14.8555 18.2926L14.4012 18.007C14.3628 17.9862 14.3255 17.9632 14.2896 17.938L5.86166 12.7672H5.85775L5.58203 12.6016V22.78C5.58633 23.459 6.10176 24.0059 6.73347 24.0016H22.867C22.8765 24.0016 22.8849 23.9968 22.8949 23.9968C23.0284 23.9876 23.1599 23.9581 23.2856 23.9092C23.34 23.8844 23.3924 23.8551 23.4425 23.8216C23.4799 23.7988 23.5441 23.749 23.5441 23.749C23.83 23.5215 23.9992 23.1623 24.0006 22.78V12.6016C24.0004 12.7962 23.9027 12.9758 23.745 13.0714Z",
    fill: "url(#paint0_linear_16320_23040)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.5,
    d: "M23.5537 12.5594V13.1835L14.8579 19.6196L5.85506 12.7694C5.85506 12.7661 5.85256 12.7634 5.84948 12.7634L5.02344 12.2294V11.7794L5.3639 11.7734L6.0839 12.2174L6.10063 12.2234L6.16203 12.2654C6.16203 12.2654 14.6234 17.4554 14.6457 17.4674L14.9695 17.6714C14.9974 17.6594 15.0253 17.6474 15.0588 17.6354C15.0755 17.6234 23.4587 12.5534 23.4587 12.5534L23.5537 12.5594Z",
    fill: "#0A2767"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.745 13.0714L23.7344 13.078L15.4181 18.106C15.3818 18.1299 15.345 18.1527 15.3065 18.1731C14.9835 18.3428 14.6058 18.3428 14.2828 18.1731C14.2446 18.1528 14.2073 18.1304 14.1712 18.106L5.85496 13.078L5.84492 13.0714C5.68436 12.9778 5.5837 12.7979 5.58203 12.6016V22.78C5.58603 23.4589 6.10128 24.0058 6.73286 24.0016C6.73286 24.0016 6.73289 24.0016 6.73292 24.0016H22.8497C23.4813 24.0059 23.9966 23.459 24.0006 22.78C24.0006 22.78 24.0006 22.78 24.0006 22.78V12.6016C24.0004 12.7962 23.9027 12.9758 23.745 13.0714Z",
    fill: "#1490DF"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M15.5381 18.0312L15.4136 18.1063C15.3775 18.1309 15.3403 18.1536 15.302 18.1741C15.1648 18.2464 15.0157 18.2888 14.8633 18.2988L18.0274 22.3212L23.5468 23.751C23.6981 23.6282 23.8184 23.4667 23.8968 23.2812L15.5381 18.0312Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.05,
    d: "M16.1018 17.6875L15.4136 18.1033C15.3775 18.128 15.3403 18.1506 15.302 18.1711C15.1648 18.2434 15.0157 18.2859 14.8633 18.2959L16.3457 22.6897L23.5485 23.7463C23.8322 23.5173 23.9993 23.1581 23.9995 22.7767V22.6453L16.1018 17.6875Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.74854 24.0015H22.8481C23.0958 24.0029 23.3374 23.9188 23.5374 23.7615L14.4006 18.0082C14.3622 17.9875 14.325 17.9644 14.289 17.9392L5.86109 12.7684H5.85719L5.58203 12.6016V22.7452C5.5814 23.4384 6.10366 24.0009 6.74854 24.0015Z",
    fill: "#28A8EA"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M13.396 5.89667V18.6947C13.395 19.1434 13.1412 19.5467 12.7541 19.7147C12.6342 19.7701 12.5051 19.7986 12.3746 19.7987H5.58203V5.39687H6.69831V4.79688H12.3746C12.9384 4.79917 13.3948 5.29052 13.396 5.89667Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.8378 6.49828V19.2963C12.8392 19.4412 12.8107 19.5847 12.7541 19.7163C12.5991 20.127 12.2288 20.3964 11.8164 20.3985H5.58203V5.39849H11.8164C11.9784 5.39674 12.138 5.44017 12.2797 5.5245C12.6218 5.70979 12.8377 6.08645 12.8378 6.49828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.8378 6.49828V18.0963C12.8351 18.7021 12.38 19.1932 11.8165 19.1985H5.58203V5.39849H11.8164C11.9784 5.39674 12.138 5.44017 12.2797 5.5245C12.6218 5.70979 12.8377 6.08645 12.8378 6.49828Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "M12.2797 6.49823V18.0962C12.2791 18.703 11.8228 19.1955 11.2583 19.1984H5.58203V5.39844H11.2583C11.8227 5.39876 12.28 5.8909 12.2797 6.49764C12.2797 6.49784 12.2797 6.49804 12.2797 6.49823Z",
    fill: "black"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.02307 5.39844H11.256C11.821 5.39844 12.2791 5.89084 12.2791 6.49823V17.4986C12.2791 18.106 11.821 18.5984 11.256 18.5984H1.02307C0.458037 18.5984 0 18.106 0 17.4986V6.49823C0 5.89084 0.45805 5.39844 1.02307 5.39844Z",
    fill: "url(#paint1_linear_16320_23040)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.19828 10.0148C3.45043 9.43725 3.85743 8.95395 4.36703 8.62697C4.93138 8.27964 5.57393 8.10649 6.22396 8.12657C6.82642 8.11252 7.42091 8.2767 7.94247 8.60116C8.43286 8.91554 8.82781 9.37617 9.0794 9.92716C9.35339 10.5343 9.48993 11.2025 9.47791 11.8772C9.49119 12.5823 9.3507 13.2809 9.06768 13.9172C8.8101 14.4878 8.40262 14.9649 7.89559 15.2893C7.35391 15.6238 6.73736 15.7922 6.11289 15.7766C5.49756 15.7925 4.88997 15.6265 4.35643 15.2965C3.8618 14.9818 3.46189 14.5206 3.20443 13.9681C2.92881 13.3698 2.79064 12.7091 2.80145 12.0415C2.78997 11.3424 2.92563 10.6496 3.19828 10.0148ZM4.44405 13.2728C4.57849 13.6379 4.80647 13.9545 5.10153 14.186C5.40208 14.4118 5.76195 14.5283 6.1285 14.5184C6.51887 14.535 6.90365 14.4145 7.22469 14.1752C7.51602 13.9444 7.73801 13.6269 7.8632 13.262C8.00314 12.8544 8.0722 12.4226 8.06692 11.9882C8.07125 11.5496 8.00633 11.1134 7.87492 10.6982C7.75886 10.3233 7.54402 9.99269 7.2565 9.74657C6.94351 9.49591 6.55976 9.36877 6.1698 9.38657C5.79531 9.37614 5.42737 9.49355 5.11883 9.72196C4.81878 9.95439 4.58647 10.2738 4.44907 10.643C4.14426 11.489 4.14268 12.4267 4.4446 13.274L4.44405 13.2728Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.8594 3.60156H22.8826V9.00156H17.8594V3.60156Z",
    fill: "#50D9FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_16320_23040",
    x1: 14.7913,
    y1: 12.6016,
    x2: 14.7913,
    y2: 24.0016,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#35B8F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#28A8EA"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_16320_23040",
    x1: 2.13312,
    y1: 4.53908,
    x2: 11.0461,
    y2: 18.899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#1784D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5,
    stopColor: "#107AD5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0A63C9"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_16320_23040"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgOutlookEmailIcon);
export default __webpack_public_path__ + "static/media/OutlookEmailIcon.94bb70c03bfb12ff1ed2c2f4890ae2ff.svg";
export { ForwardRef as ReactComponent };